
import React from "react";
import ReactModal from "react-modal";
import { useGlobalContext } from "../../context";
import DoneIcon from '@mui/icons-material/Done';

function Completed() {
    
    const {
        openCompleted, 
        setOpenCompleted
    } = useGlobalContext()
    
    return(
        <ReactModal
            isOpen = { openCompleted }
            onRequestClose = { () => setOpenCompleted(false) }
            style = {{
                overlay: {
                    position: 'fixed',
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    backgroundColor: 'rgba(0, 0, 0, 0.3)',
                    zIndex: 300,
                },
                content: {
                    width: "90%",
                    top: "5px",
                    maxWidth: '400px',
                    maxHeight: "300px",
                    height: "85vh",
                    border: 'none',
                    margin: "auto",
                    left: "5%",
                    borderRadius: "10px",
                    background: 'white',
                    WebkitOverflowScrolling: 'touch',
                    outline: 'none',
                    boxShadow: "0 0 10px rgba(0,0,0,0.3)",
                    overflowY: "auto",
                }
            }}
        >
            <DoneIcon 
                style = {{
                    margin: "50px 41% 0 40%", 
                    fontSize: "60px", 
                    color: "green"
                }}
            />
            <h3 
                style = {{
                    margin: "30px 25%", 
                    fontSize: "30px", 
                    color: "green", 
                    fontWeight: "700", 
                    fontFamily: "Verdana"
                }}
            >
                COMPLETE
            </h3>
        </ReactModal>
    )
}

export default Completed

